/*
 * toastReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 18-Sep-2024
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/toast'

const ACTION_HANDLERS = {
  [actionTypes.DO_SHOW_TOAST]: produce((draft, action) => {
    draft.toastId = action.id
    draft.toastKey = action.key
    draft.toastInfo = action.moreInfo
  }),
  [actionTypes.DO_HIDE_TOAST]: produce((draft, action) => {
    draft.toastId = ''
    draft.toastKey = ''
    draft.toastInfo = {}
  })
  // @generator reducer:type:action
}

// The initial state of the toast
const initialState = {
  toastId: '',
  toastKey: '',
  toastInfo: {}
}

const toast = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default toast
